import { render, staticRenderFns } from "./KeywordGroupRow.vue?vue&type=template&id=bbe4f24a&"
import script from "./KeywordGroupRow.vue?vue&type=script&lang=ts&"
export * from "./KeywordGroupRow.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./KeywordGroupRow.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports